$(document).ready(function () {
  ("use strict");

 

  // Menú: afegim botó i ocultem menú quan hi ha js
  $("#menu")
    .before(
      '<button class="hamburger hamburger--spring" type="button" aria-expanded="false" aria-controls="menu"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="is-sr-only">Menu</span></button>'
    )
    .attr("hidden", "true");

  // ----
  // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // ----
  var toggleMenu = document.querySelector(".navigation button");
  var menu = document.querySelector("#menu");

  if (toggleMenu) {
    toggleMenu.addEventListener("click", function () {
      var open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
      toggleMenu.setAttribute("aria-expanded", !open);
      menu.hidden = !menu.hidden;
    });
  }

  $(".hamburger").on("click", function () {
    // afegir classe al botó
    $(this).toggleClass("is-active");
    // afegir classe al body
    // $("body").toggleClass("js-menu-open");
  });

  // -------------------------------
  // Menú principal amb desplegables (https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle)
  // -------------------------------

  function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }

  var menuItems1 = document.querySelectorAll('li.has-submenu');
  var timer1, timer2;

  var parseHTML = function(str) {
      var tmp = document.implementation.createHTMLDocument();
      tmp.body.innerHTML = str;
      return tmp.body.children;
  };

  Array.prototype.forEach.call(menuItems1, function(el, i){
      var activatingA = el.querySelector('a');
      var btn = '<button type="button"><span class="is-sr-only">Mostra el submenú de "' + activatingA.text + '"</span></button>';
      activatingA.insertAdjacentHTML('afterend', btn);

      // Handle hover event for non-touch devices
      // mouseenter/mouseleave don't bubble and don't fire for child elements,
      // avoiding spurious close/open cycles when moving within the submenu.
      el.addEventListener("mouseenter", function(){
          clearTimeout(el._hoverTimer);
          this.classList.add("open");
          this.querySelector('a').setAttribute('aria-expanded', "true");
          this.querySelector('button').setAttribute('aria-expanded', "true");
      });

      el.addEventListener("mouseleave", function(){
          var self = this;
          el._hoverTimer = setTimeout(function(){
              self.classList.remove("open");
              self.querySelector('a').setAttribute('aria-expanded', "false");
              self.querySelector('button').setAttribute('aria-expanded', "false");
          }, 50);
      });

      // Handle click and touchstart events for touch devices
      el.querySelector('button').addEventListener("click", function(event){
          event.preventDefault();
          toggleSubmenu(el);
      });

      el.querySelector('button').addEventListener("touchstart", function(event){
          event.preventDefault();
          toggleSubmenu(el);
      });

      var links = el.querySelectorAll('a');
      Array.prototype.forEach.call(links, function(link, i){
          link.addEventListener("focus", function() {
              if (timer2) {
                  clearTimeout(timer2);
                  timer2 = null;
              }
          });
          link.addEventListener("blur", function(event) {
              timer2 = setTimeout(function () {
                  var openNav = document.querySelector(".has-submenu.open")
                  if (openNav) {
                      openNav.className = "has-submenu";
                      openNav.querySelector('a').setAttribute('aria-expanded', "false");
                      openNav.querySelector('button').setAttribute('aria-expanded', "false");
                  }
              }, 10);
          });
      });
  });

  function toggleSubmenu(el) {
      var isOpen = hasClass(el, "open");

      // Close any other open submenus
      var allMenus = document.querySelectorAll('li.has-submenu');
      Array.prototype.forEach.call(allMenus, function(item){
          item.classList.remove("open");
          item.querySelector('a').setAttribute('aria-expanded', "false");
          item.querySelector('button').setAttribute('aria-expanded', "false");
      });

      // Open the clicked/touched submenu if it was not already open
      if (!isOpen) {
          el.classList.add("open");
          el.querySelector('a').setAttribute('aria-expanded', "true");
          el.querySelector('button').setAttribute('aria-expanded', "true");
      }
  }

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // ----------
  // scroll top
  // ----------
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".scrolltop").addClass("visible");
    } else {
      $(".scrolltop").removeClass("visible");
    }
  });

  // ------
  // Slider
  // ------
  $('.slider').slick({
    dots: true,
    arrows: true,
    autoplay: false,
    // autoplaySpeed: 5000,
    fade: true,
  });
  $('.slider-logos').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 769,  settings: { slidesToShow: 3 } },
      { breakpoint: 560,  settings: { slidesToShow: 2 } },
      { breakpoint: 400,  settings: { slidesToShow: 1 } },
    ],
  });

  // --------------
  // Navegació fixa
  // --------------
  $(window).on('scroll', function() {
      const scrollTop = $(this).scrollTop();
      if (scrollTop >= 70) {
          $('.main-header').addClass('fixed');
      } else if (scrollTop < 30) {
          $('.main-header').removeClass('fixed');
      }
  });


   // --------
  // Counters https://github.com/srexi/purecounterjs
  // --------
  new PureCounter({
    // selector: '.purecounter',
    // start: 0,
    // end: 100,
    // duration: 2,
    // delay: 10,
    // once: true,
    // repeat: false,
    // decimals: 0,
    legacy: false,
    // filesizing: false,
    // currency: false,
    separator: true,
  });

  // -----------
  // File upload
  // -----------
  $('input[type="file"]').change(function () {
    var fileName = '';
    if (this.files && this.files[0]) {
      fileName = this.files[0].name;
    }
    $
    (this).siblings('.file-name').text(fileName);
  });

  //Form donacions puntuals
  var $altraAportacio = $("#quantitat-altra-aportacio");
  if ($altraAportacio.length > 0) {

    function enableAltraAportacio() {
      console.log('enable');
      $altraAportacio.rules('add', { required: true });
      $altraAportacio.focus();
    }

    function disableAltraAportacio() {
      console.log('disable');
      $altraAportacio.rules('remove', 'required');
      $altraAportacio.removeAttr('data-rule-required');
      $altraAportacio.removeClass('error').removeAttr('aria-invalid').removeAttr('required');
      $('#quantitat-altra-aportacio-error').hide();
    }

    // Inicialització: si ja hi ha un radio numèric seleccionat, treure el required
    console.log($(".donacio__opcions input[type='radio']:checked").val());
    if ($(".donacio__opcions input[type='radio']:checked").val() !== 'Un altre import') {
      disableAltraAportacio();
    }

    $(".donacio__opcions input[type='radio']").on('change', function() {
      if ($(this).val() === 'Un altre import') {
        console.log($(this).val());
        enableAltraAportacio();
      } else {
        disableAltraAportacio();
      }
    });

    $altraAportacio.on('click', function() {
      var $radioAltreImport = $(".donacio__opcions input[type='radio'][value='Un altre import']");
      if (!$radioAltreImport.prop('checked')) {
        console.log('ofucs');
        $radioAltreImport.prop('checked', true).trigger('change');
      }
    });
  }

});

// -------
// Donació: exclusió mútua entre radiobuttons i input numèric
// -------
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.donacio__opcions').forEach(function(container) {
    var numberInput = container.querySelector('input[type="number"]');
    var radioInputs = container.querySelectorAll('input[type="radio"]');
    if (!numberInput || !radioInputs.length) return;

    numberInput.addEventListener('input', function() {
      if (this.value !== '') {
        radioInputs.forEach(function(radio) { radio.checked = false; });
      }
    });

    radioInputs.forEach(function(radio) {
      radio.addEventListener('change', function() { numberInput.value = ''; });
    });
  });
});

// Dates Inici/Fi cercador convocatòries
// document.addEventListener("DOMContentLoaded", () => {
//   const startDateInput = document.getElementById("date_start");
//   const endDateInput = document.getElementById("date_end");
//   if (startDateInput && endDateInput) {

//     // Quan es modifica la data d'inici
//     startDateInput.addEventListener("change", () => {
//         const startDate = new Date(startDateInput.value);
//         const endDate = new Date(endDateInput.value);

//         // Si la data d'inici supera la de final, ajustem la de final
//         if (startDate && endDate && startDate > endDate) {
//             endDateInput.value = startDateInput.value;
//         }

//         // Ajustem el valor mínim per la data de final
//         endDateInput.min = startDateInput.value;
//     });

//     // Quan es modifica la data de final
//     endDateInput.addEventListener("change", () => {
//         const startDate = new Date(startDateInput.value);
//         const endDate = new Date(endDateInput.value);

//         // Si la data de final és anterior a la d'inici, ajustem la d'inici
//         if (startDate && endDate && endDate < startDate) {
//             startDateInput.value = endDateInput.value;
//         }

//         // Ajustem el valor màxim per la data d'inici
//         startDateInput.max = endDateInput.value;
//     });
//   }
// });